'use strict';

const jQuery = require('jquery');

const callback = function() {
    jQuery('<div class="iframe-editor"></div>').insertBefore(jQuery(this));
};

module.exports.build = () => {
    jQuery('iframe.edit-iframe').each(callback);
};

module.exports.apply = (content) => {
    content.$.find('iframe').each(callback);
};

module.exports.unApply = (content) => {
    content.$.find('.iframe-editor').remove();
};
